// extracted by mini-css-extract-plugin
export default {"tag":"FlexibleKeywordsContent_tag__--Foy"};